import moment from "moment";

export function formatDate(date) {
  if (moment(date, "DD-MM-YYYY", true).isValid()) {
    return date;
  }
  return moment(date).format("DD-MM-YYYY");
}

export function formatDate2(date) {
  if (moment(date, "DD/MM/YYYY", true).isValid()) {
    return date;
  }
  return moment(date).format("DD/MM/YYYY");
}
